import { takeLatest, call, put } from 'redux-saga/effects'
import answerOpenEndedCreate, {
  IAnswerOpenEndedAttributes,
} from 'api/answers/open-endeds/Create'
import I18n from 'i18n'
import { ErrorToast } from 'components/ui/toast/toastsTemplates'
import * as fromActions from '../../../actions/answer-open-ended.action'

async function createAnswerOpenEnded(data: IAnswerOpenEndedAttributes) {
  return answerOpenEndedCreate(data)
}

function* answerOpenEndedCreateEffectSaga(action: any) {
  try {
    yield call(createAnswerOpenEnded, action.payload)
    yield put(fromActions.Actions.answerOpenEndedCreateSuccess())
  } catch (error) {
    ErrorToast(I18n.t('administration.toastMessages.genericError'))
    console.log('error: ', error)
  }
}

export function* answerOpenEnderCreateWatcherSaga() {
  yield takeLatest(
    fromActions.ANSWER_OPEN_ENDED_CREATE,
    answerOpenEndedCreateEffectSaga
  )
}
